import { Injectable } from '@angular/core';
import { GetAgencyBO,  AgencyInfoBO, SaveReturnBO,  AgencyListBO, CompanyList } from '../agency/agency.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import { map, catchError } from 'rxjs/operators';
import { ColumnChangeBO } from '../list/list.model';
import { ErrorService } from 'src/app/error.service';

@Injectable({ providedIn: 'root'})

export class AgencyService extends Subject<DataStateChangeEventArgs> {

  constructor(private http: HttpClient, public errorService: ErrorService) {
    super();
  }
  /////////////////////////get Agency////////////////////////////

  getAgencyList(paramsData: GetAgencyBO): Observable<AgencyListBO[]> {
    let url = "api/Agency/GetAgencies";
    return this.http.post<AgencyListBO[]>(url, paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }
  ///////////////////////save Agency/////////////////////////////////////

  saveupdate(saveList: AgencyListBO): Observable<SaveReturnBO> {
    let url = "api/Agency/SaveAgency";
    return this.http.post<SaveReturnBO>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //////////////////////////getOverAllAgencyDropdown///////////////////////////////////////////

  getOverAllAgency(): Observable<AgencyListBO[]> {
    let url = "api/Agency/OverallAgency";
    return this.http.get<AgencyListBO[]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  ////////////////////////////////////////getOverAllAgencyInfo///////////////////////////////////

  getOverAllAgencyInfo(paramsData: URLSearchParams): Observable<AgencyInfoBO> {
    let url = "api/Agency/OverallAgencyInfo?";
    return this.http.get<AgencyInfoBO>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

 getcolumwidth(): Observable<any> {
    let url = "api/ColumnChange/getwidth?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  savecolumwidth(list: ColumnChangeBO): Observable<any> {
    let url = "api/ColumnChange/Savewidth?";
    return this.http.post<number>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  } 

  /////////////////////Statuslov /////////////////////////////////
  getLovStatus(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  } 
  /////////////// Save Company ////////////////////////

  saveupdateCompany(saveList: CompanyList): Observable<any> {
    let url = "api/Company/SaveCompany";
    return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
      //==============================get employee permission==========================================//
 getpermission(paramsData: URLSearchParams): Observable<any> {
  let url = "api/FunctionPermission/getfunctionpermissionemployee?";
  return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}
  
GetCompanyDropdown(): Observable<any> {
  let url = "api/Company/GetCompanyDropDowm?";
  return this.http.get<any>(url , { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
  )
}

}